import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
export type EditSeminarScheduleSeminarScheduleFragment = { __typename?: 'Schedule', id: string, startedAt: TimeString, endedAt: TimeString, location: string, isOnline: boolean, capacity?: number | null, applicationDue: TimeString, applicantCount: number };

export const EditSeminarScheduleSeminarScheduleFragmentDoc = gql`
    fragment EditSeminarScheduleSeminarSchedule on Schedule {
  id
  startedAt
  endedAt
  location
  isOnline
  capacity
  applicationDue
  applicantCount
}
    `;